import { IUserAchievementSummary } from '../achievements.t';
import { AchievementProgressCarouselStyled, AchievementProgressStyled } from './styled/AchievementProgressStyled';
import {
    MobileProfileGloryArenaHeaderStyled
} from '../../../mobileAppCore/components/MobileProfile/styled/MobileProfileGloryArenaStyled';
import BinIcon from '../../../components/icon/IconWrapped';
import { Carousel } from '../../../components/Carousel/Carousel';
import React, { Fragment, memo, useCallback } from 'react';
import AchievementProgressItem from './AchievementProgressItem';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { useDispatch } from 'react-redux';
import { locationSlice } from '../../Location/locationReducer';
import { LOCATION_NAMES } from '../../Location/locationConstants';

interface AchievementProgressCarouselProps {
    achievements: IUserAchievementSummary[];
}

function AchievementProgressCarousel(props: AchievementProgressCarouselProps) {
    const { getLangPath } = useLangContext();
    const { achievements } = props;
    const dispatch = useDispatch();

    const onMoreClick = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({name: LOCATION_NAMES.GLORY_ARENA}));
    }, [dispatch]);

    return <AchievementProgressStyled>
        <MobileProfileGloryArenaHeaderStyled>
            <div>{getLangPath('achievements.progress.title')}</div>
            <div className={'more'} onClick={onMoreClick}>{getLangPath('achievements.preview.more')} <BinIcon
                name={'IcForward'} size={16}/></div>
        </MobileProfileGloryArenaHeaderStyled>
        <AchievementProgressCarouselStyled>
            <Carousel showArrows={false} centerDots={true} showIndicators={false}>
                {
                    achievements.map((item) => <Fragment key={item.achievement_name}>
                        <AchievementProgressItem achievement={item}/>
                    </Fragment>)
                }
            </Carousel>
        </AchievementProgressCarouselStyled>
    </AchievementProgressStyled>;
}

export default memo(AchievementProgressCarousel);
